var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { "data-testid": "sensor_events" } },
        [
          _c("v-divider", { staticClass: "my-4" }),
          _vm._v(" "),
          _c(
            "content-header",
            {
              staticClass: "my-3",
              attrs: {
                titleClass: "title mr-2",
                description: _vm.sensorDetails,
                stackHeadingOnMobile: "",
                to: "sensors/" + _vm.sensor.id,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [_vm._v(_vm._s(_vm.sensor.name))]
                    },
                    proxy: true,
                  },
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("sensor-icon", {
                          attrs: { sensorType: _vm.sensor.type },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "subtitle",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "sensor-events__subtitle" }, [
                          _c(
                            "div",
                            {
                              staticClass: "sensor-events__place subheading",
                              attrs: { "data-testid": "content-subtitle" },
                            },
                            [_vm._v(_vm._s(_vm.sensor.place))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "sensor-events__last-request caption hidden-md-and-up",
                              attrs: {
                                "data-testid":
                                  "content-last-event-request-mobile",
                              },
                            },
                            [_vm._v(_vm._s(_vm.sensorDetails))]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                326414571
              ),
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "flex-nowrap", attrs: { "no-gutters": "" } },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.isRatMonitor
                    ? _c("rat-graph-button", {
                        staticClass: "ml-2 hidden-sm-and-down",
                        attrs: {
                          sensor: _vm.sensor,
                          requestParams: _vm.exportParams,
                          disabled:
                            _vm.sensorState === _vm.SENSOR_STATE.NO_DATA,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("sensor-events-export-button", {
                    staticClass: "ml-2 hidden-sm-and-down",
                    attrs: {
                      sensor: _vm.sensor,
                      requestParams: _vm.exportParams,
                      disabled: _vm.sensorState === _vm.SENSOR_STATE.NO_DATA,
                      "data-testid": "export_csv",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.sensorState === _vm.SENSOR_STATE.NO_DETECTION
            ? _c(
                "div",
                {
                  staticClass:
                    "sensor-status sensor-status--no-activity d-flex align-center pa-4",
                  attrs: { "data-testid": "sensor-status-no-detection" },
                },
                [
                  _c("span", { staticClass: "sensor-status__dot" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sensor-status__text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.isRatMonitor
                          ? _vm.$t("noDetection")
                          : _vm.$t("noDetectionGeneric")
                      )
                    ),
                  ]),
                ]
              )
            : _vm.sensorState === _vm.SENSOR_STATE.NO_DATA
            ? _c(
                "div",
                {
                  staticClass:
                    "sensor-status sensor-status--warning d-flex align-center pa-4",
                  attrs: { "data-testid": "sensor-status-no-data" },
                },
                [
                  _c("span", { staticClass: "sensor-status__dot" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sensor-status__text" }, [
                    _vm._v(_vm._s(_vm.$t("noData"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sensorState === _vm.SENSOR_STATE.DETECTED
            ? [
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _vm.detectedCount > 0
                      ? _c(
                          "round-button",
                          {
                            staticClass: "expand-btn",
                            attrs: {
                              icon: _vm.expanded
                                ? "fa-chevron-circle-up"
                                : "fa-chevron-circle-down",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "update:expanded",
                                  !_vm.expanded
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$mpt(_vm.$t("button.expand"))) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-row",
                  { attrs: { wrap: "" } },
                  [
                    _vm._l(_vm.displayedEvents, function (event) {
                      return [
                        _c(
                          "v-flex",
                          {
                            key: event.id,
                            staticClass: "pa-2 event-wrapper",
                            attrs: { md3: "", xs12: "" },
                          },
                          [
                            _c("event", {
                              staticClass: "event",
                              attrs: { event: event, editable: _vm.isEditable },
                              on: {
                                "event:selected": function ($event) {
                                  return _vm.$emit(
                                    "event:selected",
                                    event,
                                    _vm.events
                                  )
                                },
                                "event:hidden": function (v) {
                                  return _vm.updateEventHidden(event, v)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-4 bottom-buttons" }, [
                  _c(
                    "div",
                    {
                      ref: "listEnd",
                      staticClass: "d-flex justify-content-between",
                    },
                    [
                      _vm.eventsLoading
                        ? _c("v-progress-linear", {
                            attrs: {
                              color: "primary",
                              indeterminate: "",
                              rounded: "",
                              height: "6",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }